import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import { RouterProvider, RouterProviderProps } from 'react-router';

import { CCKeycloakProvider } from '@cccom/auth/keycloak';
import { CCEnvironmentProvider, EnvironmentType } from '@cccom/config/env';
import { CCAxiosProvider, queryClient } from '@cccom/shared/data-access';
import '@cccom/shared/i18n';
import { CCVersionLogger } from '@cccom/shared/logging';
import { Fonts } from '@cccom/shared/themes';

import { UIProvider } from './ui.context';

type AppProviderProps = {
  environment: EnvironmentType;
  routerProps: RouterProviderProps;
};

function AppProvider({ environment, routerProps }: AppProviderProps) {
  return (
    <CCEnvironmentProvider environment={environment}>
      <Fonts staticUrl={environment.STATIC_ASSETS_URL} />
      <CCKeycloakProvider>
        <StrictMode>
          <CCAxiosProvider>
            <QueryClientProvider client={queryClient}>
              <UIProvider>
                <CCVersionLogger />
                <RouterProvider {...routerProps} />
                {!environment.production && (
                  <ReactQueryDevtools initialIsOpen={false} />
                )}
              </UIProvider>
            </QueryClientProvider>
          </CCAxiosProvider>
        </StrictMode>
      </CCKeycloakProvider>
    </CCEnvironmentProvider>
  );
}

export default AppProvider;
